import { render } from "./Facebook.vue?vue&type=template&id=7ddb524d"
import script from "./Facebook.vue?vue&type=script&lang=js"
export * from "./Facebook.vue?vue&type=script&lang=js"
script.render = render

export default script